import { render, staticRenderFns } from "./LimiteCredito.vue?vue&type=template&id=0189e59d&scoped=true"
import script from "./LimiteCredito.vue?vue&type=script&lang=js"
export * from "./LimiteCredito.vue?vue&type=script&lang=js"
import style0 from "./LimiteCredito.vue?vue&type=style&index=0&id=0189e59d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0189e59d",
  null
  
)

export default component.exports